export default "__VITE_ASSET__CNPlg4Zc__"